var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{class:[ 'icon-list', _vm.item.classes ]},_vm._l((_vm.item.items),function(line,index){return _c('li',{key:index},[(line.icon)?_c('span',{class:`icon icon-${line.icon}`}):_vm._e(),_c('p',{class:line.classes,domProps:{"innerHTML":_vm._s(line.html)}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }